module.exports = __webpack_public_path__ + "img/logo_uangme.2931abef.png";